<mat-tab-group color="accent" class="datatables-tabs" animationDuration="0ms">
    <mat-tab [label]="'invest.eval.compare.title.shortLabel' | translate">
        <app-compare [dataBlocks]="invest.compare"></app-compare>
    </mat-tab>
    <mat-tab [label]="'invest.eval.overview.title.shortLabel' | translate">
        <app-overview [dataBlocks]="invest.overview"></app-overview>
    </mat-tab>
</mat-tab-group>
